import { render, staticRenderFns } from "./HealthCheckIntro.vue?vue&type=template&id=0b71a5ea&"
import script from "./HealthCheckIntro.vue?vue&type=script&lang=js&"
export * from "./HealthCheckIntro.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheckIntro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports